import React,{useState,useEffect} from 'react'

import { Link, NavLink, useNavigate } from 'react-router-dom'
import useBusinessInfo from '../../hooks/useBusinessInfo';
import moment from 'moment';
import { Home } from '@mui/icons-material';

function CustomerHeader() {

    const businessInfo = useBusinessInfo();
    const [customerPhone,setCustomerPhone] = useState(localStorage.getItem("guestPhone")); 

    return (
        <>
        <nav className="navbar navbar-expand-lg bg-white  sticky-top">
            <div className="container-fluid">
                <Link className="me-5" to="/">
                    {businessInfo?.logo !== null ?
                            <img src={businessInfo?.logo} style={{maxHeight:40, width:"auto"}} />
                            :
                            <h3>{businessInfo?.title}</h3>
                        }
                </Link> {/* navbar-brand  */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    {/*
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{fontSize:"18px"}}>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/"> <Home /> Home</NavLink></li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">Dropdown</a>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" href="#">Link</a></li>
                                <li><a className="dropdown-item" href="#">Another link</a></li>
                                <li><a className="dropdown-item" href="#">A third link</a></li>
                            </ul>
                        </li>
                    </ul>
                    */}
                    {/* Just for Alignment  */}
                    
                        <div className=" me-auto "></div>
                    

                        <ul className="navbar-nav">
                            {customerPhone ?
                                <li className="nav-item dropdown">
                                    <a className="btn " style={{borderRadius:"50px"}} href="!#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> 
                                        Hello {customerPhone} !
                                    </a>
                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                                        <li><hr className="dropdown-divider"/></li>
                                    </ul>
                                </li>
                                :
                                <li className="nav-item"> Hello Guest !</li>
                            }
                        </ul>
                </div>
            </div>
        </nav>
        </>
    )
}

export default CustomerHeader